import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //  this.$store.state.$computer
    // 线上的
    // $url: "https://test-api.hwkjpay.com/",
    $url: "https://api.hwkjpay.com/",
    $imgUrl: "https://merchant-1317461711.cos.ap-nanjing.myqcloud.com/",
    SaasToken: window.localStorage.getItem("SaasToken")
      ? window.localStorage.getItem("SaasToken")
      : "",
    HWsaas: window.localStorage.getItem("HWsaas")
      ? JSON.parse(window.localStorage.getItem("HWsaas"))
      : {},
    $computer: true,
  },
  mutations: {
    // this.$store.commit("Collapse", "");
    token(state, weather) {
      state.SaasToken = weather;
    },
    HWsaas(state, weather) {
      state.HWsaas = weather;
    },
    computer(state, weather) {
      state.$computer = weather;
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js